module.exports = __webpack_public_path__ + "img/header-burger.f996650e.svg";